module.exports = __webpack_public_path__ + "img/rjtl.0800209e.jpg";